export default __webpack_public_path__ + "static/media/ally_background_l2.9217a29e.jpg";